/**
 * 1011 评论线「竞品账号 / 指定内容」的前端小工具。
 * 上限与后端 AcqPeerTargetService 同数 —— 超了前端先拦,省一次 400。
 */
export const PEER_ACCOUNTS_MAX = 10;
export const PEER_POSTS_MAX = 20;

/** 文本框 → 清单:一行一条,去空行、去首尾空白、去重(保序)。 */
export function parsePeerLines(text: string): string[] {
  const out: string[] = [];
  for (const raw of text.split(/\r?\n/)) {
    const line = raw.trim();
    if (line && !out.includes(line)) out.push(line);
  }
  return out;
}
